import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@modules/auth/auth.service';
import { SharedService } from '@core/services/shared.service';
import { StorageService } from '@core/services/storage.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Matensa';
  message;
  _spinner: boolean = true;
  _withLoader: boolean = true;
  get spinner() {
    return this._spinner
  }
  get withLoader() {
    return this._withLoader
  }
  public innerWidth: any;

  constructor(
    private spinnerngx: NgxSpinnerService,
    private sharedService: SharedService,
    private _StorageService: StorageService,
    private _AuthService: AuthService,
    private cdr: ChangeDetectorRef
  ) {

  }
  ngOnInit() {
    this.sharedService.isLoading.subscribe(state => {
      this._spinner = state
    });
    this.sharedService.withLoader.subscribe(state => {
      this._withLoader = state
    });
    this.spinnerngx.show();
  }


  ////////////////////
  ////////////////////////////////////
}
